(function () {
  function textFrom(element) {
    return (element ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function directChild(parent, selector) {
    if (!parent) return null;
    return Array.prototype.find.call(parent.children, function (child) {
      return child.matches(selector);
    }) || null;
  }

  function linkLabel(anchor) {
    if (!anchor) return '';
    var labelSpans = Array.prototype.filter.call(anchor.querySelectorAll('span:not(.cp-swatch)'), function (span) {
      return textFrom(span);
    });
    return textFrom(labelSpans[labelSpans.length - 1] || anchor);
  }

  function cloneMenuSwatch(anchor) {
    var swatch = anchor ? anchor.querySelector('.cp-swatch.cp-image, .cp-swatch.cp-color') : null;
    if (!swatch) return null;

    var clone = swatch.cloneNode(true);
    var image = clone.querySelector('img');

    clone.classList.add('cp-mobile-mega-link-image');
    if (swatch.classList.contains('cp-color')) {
      clone.classList.add('cp-mobile-mega-link-image--color');
    }
    clone.setAttribute('aria-hidden', 'true');

    if (image) {
      image.alt = '';
      image.loading = 'lazy';
    }

    return clone;
  }

  function createChevron() {
    var span = document.createElement('span');
    span.className = 'cp-mobile-mega-chevron';
    span.setAttribute('aria-hidden', 'true');
    return span;
  }

  function copyLinkAttributes(source, destination) {
    if (!source || !destination) return;

    if (source.target) {
      destination.target = source.target;
    }

    if (source.rel) {
      destination.rel = source.rel;
    }
  }

  function createLink(anchor, className) {
    var link = document.createElement('a');
    var image = cloneMenuSwatch(anchor);
    var label = document.createElement('span');

    link.className = className;
    link.href = anchor ? anchor.href : '#';
    copyLinkAttributes(anchor, link);

    if (image) {
      link.classList.add(className + '--with-image');
      link.appendChild(image);
    }

    label.className = 'cp-mobile-mega-link-label';
    label.textContent = linkLabel(anchor);
    link.appendChild(label);

    return link;
  }

  function createAllLink(anchor) {
    var link = createLink(anchor, 'cp-mobile-mega-all-link');
    if (anchor && anchor.classList.contains('cp-megamenu-special-all-link--outline')) {
      link.classList.add('cp-mobile-mega-all-link--outline');
    }
    return link;
  }

  function cloneCardLink(anchor, className) {
    if (!anchor || !textFrom(anchor)) return null;

    var link = document.createElement('a');
    link.className = className;
    link.href = anchor.href;
    link.textContent = textFrom(anchor);
    copyLinkAttributes(anchor, link);
    return link;
  }

  function buildAccordion(group, index) {
    var heading = textFrom(group.querySelector('.cp-megamenu-special-title'));
    if (!heading) return null;

    var accordion = document.createElement('div');
    accordion.className = 'cp-mobile-mega-accordion';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cp-mobile-mega-accordion-trigger';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', 'cp-mobile-mega-panel-' + index);
    button.appendChild(document.createTextNode(heading));
    button.appendChild(createChevron());

    var panel = document.createElement('div');
    panel.className = 'cp-mobile-mega-accordion-panel';
    panel.id = 'cp-mobile-mega-panel-' + index;

    Array.prototype.forEach.call(group.querySelectorAll('.cp-megamenu-special-links-item a'), function (anchor) {
      var label = linkLabel(anchor);
      if (!label) return;
      panel.appendChild(createLink(anchor, 'cp-mobile-mega-accordion-link'));
    });

    var allLink = directChild(group, '.cp-megamenu-special-all-link');
    if (allLink && linkLabel(allLink) && !allLink.classList.contains('cp-megamenu-special-all-link--outline')) {
      panel.appendChild(createAllLink(allLink));
    }

    button.addEventListener('click', function () {
      var parent = accordion.parentElement;
      if (parent) {
        Array.prototype.forEach.call(parent.querySelectorAll('.cp-mobile-mega-accordion.is-open'), function (openItem) {
          if (openItem !== accordion) {
            openItem.classList.remove('is-open');
            var openButton = openItem.querySelector('.cp-mobile-mega-accordion-trigger');
            if (openButton) openButton.setAttribute('aria-expanded', 'false');
          }
        });
      }

      var isOpen = accordion.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    accordion.appendChild(button);
    accordion.appendChild(panel);
    return accordion;
  }

  function buildFeatured(group) {
    var featured = document.createElement('div');
    featured.className = 'cp-mobile-mega-featured';

    Array.prototype.forEach.call(group.querySelectorAll('.cp-megamenu-special-links-item a'), function (anchor) {
      var label = linkLabel(anchor);
      if (!label) return;
      featured.appendChild(createLink(anchor, 'cp-mobile-mega-featured-link'));
    });

    var allLink = directChild(group, '.cp-megamenu-special-all-link');
    if (allLink && linkLabel(allLink) && !allLink.classList.contains('cp-megamenu-special-all-link--outline')) {
      featured.appendChild(createAllLink(allLink));
    }

    return featured.childElementCount ? featured : null;
  }

  function buildImageCard(card) {
    var sourceLink = card.querySelector(
      '.cp-theme-mega-image-card-title[href], .cp-theme-mega-image-card-media-link[href]'
    );
    var image = card.querySelector('.cp-theme-mega-image-card-media img');
    var title = textFrom(card.querySelector('.cp-theme-mega-image-card-title'));
    var text = textFrom(card.querySelector('.cp-theme-mega-image-card-text'));
    var productLink = card.querySelector('.cp-theme-mega-image-card-product-link');
    var secondaryLink = card.querySelector('.cp-theme-mega-image-card-secondary-link');
    var hasCardLinks = Boolean(productLink || secondaryLink);

    if (!image && !title && !text && !productLink && !secondaryLink) return null;

    var mobileCard = document.createElement(sourceLink && !hasCardLinks ? 'a' : 'div');
    mobileCard.className = 'cp-mobile-mega-image-card';

    if (sourceLink && !hasCardLinks) {
      mobileCard.href = sourceLink.href;
      copyLinkAttributes(sourceLink, mobileCard);
    }

    if (image) {
      var media = document.createElement('span');
      var imageClone = image.cloneNode(true);

      media.className = 'cp-mobile-mega-image-card-media';
      imageClone.loading = 'lazy';
      media.appendChild(imageClone);
      mobileCard.appendChild(media);
    }

    if (title || text || productLink || secondaryLink) {
      var content = document.createElement('span');
      content.className = 'cp-mobile-mega-image-card-content';

      if (text) {
        var textEl = document.createElement('span');
        textEl.className = 'cp-mobile-mega-image-card-text';
        textEl.textContent = text;
        content.appendChild(textEl);
      }

      if (title) {
        var titleEl = document.createElement('span');
        titleEl.className = 'cp-mobile-mega-image-card-title';
        titleEl.textContent = title;
        content.appendChild(titleEl);
      }

      var mobileProductLink = cloneCardLink(productLink, 'cp-mobile-mega-image-card-product-link');
      var mobileSecondaryLink = cloneCardLink(secondaryLink, 'cp-mobile-mega-image-card-secondary-link');

      if (mobileProductLink) {
        content.appendChild(mobileProductLink);
      }

      if (mobileSecondaryLink) {
        content.appendChild(mobileSecondaryLink);
      }

      mobileCard.appendChild(content);
    }

    return mobileCard;
  }

  function initMobileMegaMenu() {
    var root = document.querySelector('[data-cp-mobile-mega-menu]');
    var topList = document.querySelector('[data-cp-mobile-mega-top-list]');
    var subTitle = document.querySelector('[data-cp-mobile-mega-sub-title]');
    var subContent = document.querySelector('[data-cp-mobile-mega-sub-content]');
    var backButton = document.querySelector('[data-cp-mobile-mega-back]');
    var mainView = document.querySelector('[data-cp-mobile-mega-view="main"]');
    var subView = document.querySelector('[data-cp-mobile-mega-view="submenu"]');
    var desktopItems = Array.prototype.slice.call(document.querySelectorAll('.cp-theme-mega-nav .cp-theme-mega-item'));

    if (!root || !topList || !subTitle || !subContent || !mainView || !subView || !desktopItems.length) {
      return;
    }

    function showMain() {
      root.classList.remove('is-submenu-open');
      mainView.classList.add('is-active');
      subView.classList.remove('is-active');
      subContent.innerHTML = '';
    }

    function showSubmenu(item, label) {
      var panel = directChild(item, '.cp-theme-mega-panel') || item.querySelector('.cp-theme-mega-panel');
      if (!panel) return;

      subTitle.textContent = label;
      subContent.innerHTML = '';

      var groups = Array.prototype.slice.call(panel.querySelectorAll('.cp-theme-mega-group'));
      var imageCards = Array.prototype.slice.call(panel.querySelectorAll('.cp-theme-mega-image-card'));
      var featuredGroups = [];
      var accordionGroups = [];

      groups.forEach(function (group) {
        var allLink = directChild(group, '.cp-megamenu-special-all-link--outline');
        if (allLink && linkLabel(allLink)) {
          subContent.appendChild(createAllLink(allLink));
        }
      });

      groups.forEach(function (group) {
        var heading = textFrom(group.querySelector('.cp-megamenu-special-title'));
        if (!heading) return;
        if (heading.toLowerCase() === 'featured') {
          featuredGroups.push(group);
        } else {
          accordionGroups.push(group);
        }
      });

      accordionGroups.forEach(function (group, index) {
        var accordion = buildAccordion(group, index);
        if (accordion) subContent.appendChild(accordion);
      });

      featuredGroups.forEach(function (group) {
        var featured = buildFeatured(group);
        if (featured) {
          var divider = document.createElement('div');
          divider.className = 'cp-mobile-mega-divider';
          subContent.appendChild(divider);
          subContent.appendChild(featured);
        }
      });

      if (imageCards.length) {
        if (subContent.childElementCount) {
          var imageDivider = document.createElement('div');
          imageDivider.className = 'cp-mobile-mega-divider';
          subContent.appendChild(imageDivider);
        }

        var imageCardsWrap = document.createElement('div');
        imageCardsWrap.className = 'cp-mobile-mega-image-cards';

        imageCards.forEach(function (card) {
          var imageCard = buildImageCard(card);
          if (imageCard) imageCardsWrap.appendChild(imageCard);
        });

        if (imageCardsWrap.childElementCount) {
          subContent.appendChild(imageCardsWrap);
        }
      }

      root.classList.add('is-submenu-open');
      mainView.classList.remove('is-active');
      subView.classList.add('is-active');
      root.closest('#mobile-menu').scrollTop = 0;
    }

    topList.innerHTML = '';

    desktopItems.forEach(function (item) {
      var trigger = directChild(item, '.cp-theme-mega-trigger') || item.querySelector('.cp-theme-mega-trigger');
      if (!trigger) return;

      var label = textFrom(trigger);
      var panel = directChild(item, '.cp-theme-mega-panel') || item.querySelector('.cp-theme-mega-panel');
      var row;

      if (panel) {
        row = document.createElement('button');
        row.type = 'button';
        row.className = 'cp-mobile-mega-top-item';
        row.appendChild(document.createTextNode(label));
        row.appendChild(createChevron());
        row.addEventListener('click', function () {
          showSubmenu(item, label);
        });
      } else {
        row = document.createElement('a');
        row.className = 'cp-mobile-mega-top-item cp-mobile-mega-top-item--link';
        row.href = trigger.href || '#';
        row.textContent = label;
      }

      topList.appendChild(row);
    });

    if (backButton) {
      backButton.addEventListener('click', showMain);
    }

    var closeButton = document.querySelector('#mobile-menu > .close');
    if (closeButton) {
      closeButton.addEventListener('click', showMain);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMegaMenu);
  } else {
    initMobileMegaMenu();
  }
})();
